module.exports = __webpack_public_path__ + "static/img/2.076bc05.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/toutiao/2.png
// module id = OCs3
// module chunks = 156